export default __webpack_public_path__ + "static/media/error.40da4cfe.svg";